import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'bg-primary-100/60',
    text: 'text-primary-700',
    iconBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/60',
    text: 'text-accent-700',
    iconBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/60',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-500',
  },
};

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          我们的咨询服务
        </h2>
        <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
          覆盖两性健康各个维度，无论您面临怎样的问题，都能在这里找到专业的支持与指导
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat) => {
          const colors = colorMap[cat.color] || colorMap.primary;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${colors.iconBg} mb-4`}>
                <i className={`${cat.icon} text-lg text-background-50`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">{cat.articleCount} 篇相关文章</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}